(function () {
  'use strict';

  var ATTR = 'data-product-list-swiper';
  var instances = new WeakMap();
  var mobileLayoutQuery = window.matchMedia('(max-width: 767px)');

  function syncNavigationHeight(shell) {
    if (!shell) return;
    var figure = shell.querySelector('.idx-card__figure');
    if (!figure) return;
    var height = figure.getBoundingClientRect().height;
    if (height > 0) shell.style.setProperty('--product-list-media-height', height + 'px');
  }

  function primeImage(image, highPriority) {
    if (!image || image.dataset.productListPrimed === 'true') return;
    image.dataset.productListPrimed = 'true';
    image.loading = 'eager';
    image.fetchPriority = highPriority ? 'high' : 'low';
    if (typeof image.decode === 'function') image.decode().catch(function () {});
  }

  function primeVisibleImages(swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;

    var visibleCount = Math.ceil(Number(swiper.params.slidesPerView) || 1);
    var start = Math.max(0, swiper.activeIndex || 0);

    for (var offset = 0; offset < visibleCount; offset += 1) {
      var slide = swiper.slides[start + offset];
      if (!slide) break;
      primeImage(slide.querySelector('.idx-card__image'), true);
    }
  }

  function primeRemainingImages(swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;

    var images = Array.prototype.map.call(swiper.slides, function (slide) {
      return slide.querySelector('.idx-card__image');
    }).filter(Boolean);
    var index = 0;

    function schedule(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1200 });
      } else {
        window.setTimeout(function () {
          callback(null);
        }, 650);
      }
    }

    function processBatch(deadline) {
      var processed = 0;
      while (index < images.length && processed < 2) {
        if (deadline && deadline.timeRemaining() < 4 && !deadline.didTimeout) break;
        primeImage(images[index], false);
        index += 1;
        processed += 1;
      }
      if (index < images.length) schedule(processBatch);
    }

    schedule(processBatch);
  }

  function init(root) {
    if (!root || instances.has(root) || typeof Swiper === 'undefined') return;

    var slideCount = root.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var shell = root.closest('.product-list-shell');
    var navRoot = shell ? shell.querySelector('.swiper-buttons') : root.querySelector('.swiper-buttons');
    var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : null;
    var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : null;

    var useNativeMobileScroll = mobileLayoutQuery.matches;
    var swiper = new Swiper(root, {
      cssMode: useNativeMobileScroll,
      slidesPerView: 2.2,
      spaceBetween: 12,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      threshold: 5,
      touchStartPreventDefault: false,
      passiveListeners: true,
      watchSlidesProgress: false,
      preloadImages: false,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
      on: {
        init: function () {
          primeVisibleImages(this);
          primeRemainingImages(this);
        },
        breakpoint: function () {
          primeVisibleImages(this);
        },
      },
    });

    primeVisibleImages(swiper);
    syncNavigationHeight(shell);

    var resizeObserver = null;
    var resizeHandler = null;
    var figure = shell ? shell.querySelector('.idx-card__figure') : null;
    if (figure && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        syncNavigationHeight(shell);
      });
      resizeObserver.observe(figure);
    } else {
      resizeHandler = function () {
        syncNavigationHeight(shell);
      };
      window.addEventListener('resize', resizeHandler);
    }

    instances.set(root, {
      swiper: swiper,
      resizeObserver: resizeObserver,
      resizeHandler: resizeHandler,
    });
  }

  function destroyIn(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(function (root) {
      var instance = instances.get(root);
      if (!instance) return;
      if (instance.resizeObserver) instance.resizeObserver.disconnect();
      if (instance.resizeHandler) window.removeEventListener('resize', instance.resizeHandler);
      instance.swiper.destroy(true, true);
      instances.delete(root);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyIn(event.target);
  });
})();
